module.exports = __webpack_public_path__ + "static/media/5.548dd680.svg";